var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[_c('file-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }